import { useAuth } from "../context/AuthContext";
import { KPI_HISTORIA } from "../data/demoData";
import { estadoColor } from "../utils/estadoColor";
import Card from "../components/ui/Card";
import MetricCard from "../components/ui/MetricCard";
import SectionHeader from "../components/ui/SectionHeader";
import Table from "../components/ui/Table";
import Badge from "../components/ui/Badge";
import Sparkline from "../components/ui/Sparkline";
import MiniBar from "../components/ui/MiniBar";

export default function ModuloDashboard({ equipos, tickets, repuestos, presupuestos, auditorias, movimientosStock, onNotify }) {  const { puede } = useAuth();
  const abiertos = tickets.filter(t => !["Cerrado", "Entregado"].includes(t.estado)).length;
  const stockCritico = repuestos.filter(r => r.stock <= 3).length;
  const pendientesPres = presupuestos.filter(p => p.estado === "Pendiente").length;
  const aprobados = presupuestos.filter(p => p.estado === "Aprobado").length;
  const total = presupuestos.length;
  const tasaAprobacion = total > 0 ? Math.round((aprobados / total) * 100) : 0;

  const alertas = [
    ...repuestos.filter(r => r.stock <= 3).map(r => ({ tipo: "danger", msg: `Stock crítico: ${r.nombre} (${r.stock} u.)` })),
    ...tickets.filter(t => t.estado === "Diagnóstico").map(t => ({ tipo: "warning", msg: `Ticket #${t.id} en diagnóstico` })),
    ...presupuestos.filter(p => p.estado === "Pendiente").map(p => ({ tipo: "warning", msg: `Presupuesto #${p.id} pendiente (${p.cliente})` })),
  ].slice(0, 5);

  return (
    <div>
      <div className="grid grid--4">
        <MetricCard label="Tickets abiertos" value={abiertos} sub="activos hoy" />
        <MetricCard label="Stock crítico" value={stockCritico} sub="repuestos ≤3 u." color={stockCritico > 0 ? "danger" : "success"} />
        <MetricCard label="Presupuestos pend." value={pendientesPres} sub="sin respuesta" color={pendientesPres > 0 ? "warning" : "success"} />
        <MetricCard label="Tasa de aprobación" value={`${tasaAprobacion}%`} sub="presupuestos" color={tasaAprobacion >= 80 ? "success" : "warning"} />
      </div>

      <div className="grid grid--2">
        <Card>
          <p className="text-muted text-sm mb-2">Tendencia tasa de confirmación</p>
          <Sparkline data={KPI_HISTORIA.map(k => k.tasa)} height={50} />
          <div className="flex justify-between mt-1">
            {KPI_HISTORIA.map(k => <span key={k.mes} className="text-xs text-muted">{k.mes}</span>)}
          </div>
        </Card>
        <Card>
          <p className="text-muted text-sm mb-2">Tiempo promedio reparación (días)</p>
          <MiniBar
            data={KPI_HISTORIA.map(k => ({ v: k.tiempo, l: k.mes }))}
            colors={KPI_HISTORIA.map(k => k.tiempo > 6 ? "#fca5a5" : k.tiempo > 5 ? "#fde68a" : "#86efac")}
            height={60}
          />
        </Card>
      </div>

      <Card>
        <SectionHeader title="Alertas activas" />
        {alertas.length === 0 ? (
          <p className="text-muted">✓ Sin alertas críticas en este momento</p>
        ) : alertas.map((a, i) => (
          <Card key={i} className={`alert-card alert-card--${a.tipo} ${puede("ver_auditorias") ? "alert-card--clickable" : ""}`}
            onClick={() => puede("ver_auditorias") && onNotify?.(a.msg, a.tipo === "danger" ? "error" : "warning")}>
            <div className="alert-card__content">
              <span className="alert-card__icon">{a.tipo === "danger" ? "🔴" : "🟡"}</span>
              <span className="alert-card__message">{a.msg}</span>
            </div>
          </Card>
        ))}
      </Card>

      <div className="mt-4">
        <Card>
          <SectionHeader title="Últimas acciones" />
          <Table
            cols={["Hora", "Usuario", "Acción", "Módulo", "Estado"]}
            rows={auditorias.slice(0, 5).map(a => [
              <span className="text-xs text-muted">{a.fecha}</span>,
              a.usuario,
              a.accion,
              <Badge color="muted">{a.modulo}</Badge>,
              <Badge color={estadoColor(a.resultado)}>{a.resultado}</Badge>,
            ])}
          />
        </Card>
      </div>
        {/* 🆕 Últimos movimientos de stock */}
        {movimientosStock && movimientosStock.length > 0 && (
          <div className="mt-4">
            <Card>
              <SectionHeader title="Últimos movimientos de stock" />
              <Table
                cols={["Fecha", "Repuesto", "Cantidad", "Tipo", "Usuario", "Motivo"]}
                rows={movimientosStock.slice(0, 5).map(m => [
                  <span className="text-xs text-muted">{m.fecha}</span>,
                  <span>{m.repuesto_nombre}</span>,
                  <span className={m.cantidad > 0 ? "text-success font-semibold" : "text-danger font-semibold"}>
                    {m.cantidad > 0 ? `+${m.cantidad}` : m.cantidad}
                  </span>,
                  <Badge color={m.tipo === "Suma" ? "success" : "danger"}>{m.tipo}</Badge>,
                  <span>{m.usuario}</span>,
                  <span className="text-xs text-muted">{m.motivo || "—"}</span>,
                ])}
              />
            </Card>
          </div>
        )}
    </div>
  );
}